import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateUserRequest } from '@/openapi';
import { UsersService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useCreateUserFromPartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (partnerId: number) => {
      const requestBody: CreateUserRequest = {
        userType: 'partner',
        partnerId: partnerId,
      };
      return UsersService.usersServiceCreateUser({ body: requestBody });
    },
    onSettled: async (_data, _error) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.users.list() }),
        queryClient.invalidateQueries({ queryKey: queryKeys.partners.list() }),
        // Invalidate specific partner data if we have their user ID
        _data?.data?.uid &&
          queryClient.invalidateQueries({
            queryKey: queryKeys.users.details(_data.data.uid),
          }),
      ]);
    },
  });
};
